var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossWht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.19 48.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2.83px;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24.09,
    cy: 24.09,
    r: 22.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32,12.76,24.41,20.3l-7.23-7.23a2.81,2.81,0,0,0-4,4l7.23,7.23L12.9,31.81a2.69,2.69,0,1,0,3.8,3.79l7.54-7.54,7.22,7.23a2.81,2.81,0,0,0,4-4L28.2,24.09l7.54-7.53A2.69,2.69,0,1,0,32,12.76"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossWht);
export default __webpack_public_path__ + "static/media/cross_wht.dc37aab7b62f9ad4efb67db27e3a3050.svg";
export { ForwardRef as ReactComponent };